module.exports = __webpack_public_path__ + "media/images/front/home/certificados_m-9e53c01eee81e8ea0dfec2854f3c81da.jpg";